import React from 'react';
import { CheckCircle, Phone } from 'lucide-react';
import { QuickQuoteForm } from './QuickQuoteForm';

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-br from-blue-50 via-white to-blue-50 pt-16">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="text-center lg:text-left space-y-8">
            {/* Trust Badge */}
            <div className="inline-flex items-center justify-center lg:justify-start space-x-2 bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium">
              <CheckCircle className="w-4 h-4" />
              <span>CPA + Licensed Mortgage Specialist | Colorado</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Is a Reverse Mortgage Right for 
              <span className="block text-blue-600 mt-2">Your Retirement Plan?</span>
            </h1>

            <p className="text-xl text-gray-600 leading-relaxed">
              <strong className="text-gray-900">This isn't just a loan decision—it's a retirement planning decision.</strong> As a Licensed Mortgage Specialist with a CPA background, I'll look at how a reverse mortgage fits alongside your tax situation, Social Security timing, and estate goals.
            </p>

            {/* Key Benefits */}
            <div className="grid sm:grid-cols-2 gap-4">
              {[
                'Tax-bracket coordination',
                'Portfolio protection strategy',
                'Estate wealth preservation',
                'Tax-free income alternative'
              ].map((benefit) => (
                <div key={benefit} className="flex items-center space-x-2">
                  <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
                  <span className="text-gray-700">{benefit}</span>
                </div>
              ))}
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-2 text-gray-600">
              <Phone className="w-5 h-5" />
              <span>Questions? Call <a href="tel:+17203078711" className="font-semibold text-blue-600 hover:underline">(720) 307-8711</a></span>
            </div>
          </div>

          {/* Right Column - Quick Quote Form */}
          <div className="lg:pl-8">
            <QuickQuoteForm />
          </div>
        </div>
      </div>
    </section>
  );
};